import React from 'react';
import EmptyState from '../EmptyState';
import { COPY } from '../../../contracts/copyMap';

const NoFaceRejection = ({ onRetry }) => (
  <EmptyState
    headline={COPY.REJECT_NO_FACE_HEADLINE}
    subtitle={COPY.REJECT_NO_FACE_SUBTITLE}
    ctaLabel={COPY.TRY_AGAIN_CTA}
    onCta={onRetry}
  />
);

export default NoFaceRejection;
